jQuery(document).ready(function($) {

    // Carousel photo du bloc médias (single actualité).
    var $medias = $(".medias");
    if ($medias.find(".pc-track").length) {
        initPcCarousel($medias);
    }

    // Vidéo en poster + play : on ne charge le fichier qu'au clic.
    $medias.on("click", ".media-play", function() {
        var $wrap = $(this).closest(".media-video");
        var src = $wrap.attr("data-src");
        if (!src) return;

        var video = document.createElement("video");
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;

        $wrap.empty().append(video);
    });

});
